import _ from 'lodash';
import { useHistory } from "react-router-dom";
import React, { Fragment, useState } from 'react';
import { inject, observer } from 'mobx-react';
import config from 'client/shared/config';

import {
	CardNumberElement,
	CardCvcElement,
	CardExpiryElement,
} from '@stripe/react-stripe-js';

import {
	FieldFactory
} from 'client/shared/components';

function useForceUpdate(){
    const [value, setValue] = useState(0);
    return () => setValue(value => value + 1);
}

const CARD_ELEMENT_OPTIONS = {
	iconStyle: 'solid',
	style: {
		base: {
			'color': '#fff',
			'fontFamily': "'NTR', sans-serif",
			'fontSize': '1.2rem',
			'borderBottom': '1px solid #fff'
		},
		invalid: {
			iconColor: '#eb1c26',
			color: '#eb1c26',
		}
	}
};

const Field = (props) => (
	<FieldFactory
		{ ...props }
		noFieldClass
	/>
);

const CheckoutFormHeader = ({ name }) => (
	<Fragment>
		<div className="checkout-artist-name">{ name }</div>
		<div className="checkout-price">$9.99/yr <span style={{fontSize:'0.6em'}}>plus tax</span></div>
		<div className="checkout-blurb">
			Download and keep all songs in this catalog an unlimited number of times. 
			Any new songs added to catalog will automatically be available to download and keep while your subscription is active.
		</div>
	</Fragment>
);

const CheckOutFormSubmitButton = ({ member, artistID, membersBFFStore }) => {
	const paymentMethodID = member.paymentCards[0].id;
	return (
		<div className="row" style={{'justifyContent': 'center'}}>
			<button
				className="button neo subscribeModal margin-top-0 margin-bottom-0"
				onClick={async () => {
					await membersBFFStore.subscribeToArtist({ artistID, paymentMethodID });
				}}
			>
				Confirm Subscription
			</button>
		</div>
	);
};


const CheckoutFormCardDisplay = ({ member, artistID, membersBFFStore }) => {
	const { paymentCards } = member;
	const history = useHistory();
	if(!_.isEmpty(paymentCards[0])) {
		let paymentMethodID = paymentCards[0].id
		console.log(paymentMethodID, membersBFFStore);
		return (
			<div className="row align-spaced">
				<button className="button neo" onClick={async () => {
					await membersBFFStore.subscribeToArtist({ artistID, paymentMethodID });
				}}>
					Confirm Subscription
				</button>
			</div>
		)
	}
	else {
		return (
			<div className="row align-spaced" style={{alignItems: "center"}}>
				<p>No payment information found.</p>
				<button
					className="button neo"
					data-ta="manage-payment-method-button"
					onClick={() => {
						history.push(`/account/manage-account?redirectTo=${artistID}`)
					}}
				>
					Manage Payment Method
				</button>
			</div>
		)
	}
};

const injectWithStores = inject('userStore', 'apiStore', 'formStore');

export default injectWithStores(
	observer(({ artist, userStore, apiStore, formStore, handleCloseModal, membersBFFStore }) => {
		const [ formElem, setFormElem ] = useState('existingCard');
		const member = userStore.getLoggedInUser();
		const forceUpdate = useForceUpdate();
		console.log(member);
		const SubmitButton = () => (
			<CheckOutFormSubmitButton
				member={ member }
				artistID={ artist.id }
				membersBFFStore={ membersBFFStore }
			/>
		);

		if (membersBFFStore.isModalDataSuccess) {
			const { paths: { profileImgBasePath } } = config;
			return (
				<div className="checkout margin-horizontal-1 margin-bottom-1">
					{/* <div className="checkout-artist-name">Congratulations!</div> */}
					<div className="checkout-price">You're now officially supporting { artist.name }!</div>
					
					<div className="checkout-blurb">
						Every new release will be added to your library to download and keep anytime.
					</div>


					<div className="checkout-price">Fans like you also love these artists...</div>
					<div className="grid-x align-justify align-middle">
						{ membersBFFStore.relatedArtists.map((artist, index) => {
							return (
								<div className="cell small-4">
									<div className="grid-y align-justify align-middle" key={index}>
										<div className="grid-x cell small-6 text-center">
											<a 
												className="image medium"
												href="#/artist/65d26883639dfd1cf7ab95cc/tracks"
												style={{
													'display': 'block',
													'backgroundImage': `url("${profileImgBasePath}/${artist.profileImage}")`,
													'width': '10em',
													'height': '10em'
												}}></a>
										</div>
										<div className="margin-top-1 text-center">
											<span className="carousel-label">{ artist.name }</span>
											<span className="checkout-label lite" style={{maxWidth:'11.5rem;', fontSize:'1.1em;'}}>{ artist.genreLabel }</span>
										</div>
									</div>
								</div>
							)
						})}
					</div>

					<div className="row align-spaced" style={{marginTop:'5vh;'}}>
						<button
							type="button"
							className="button neo"
							onClick={ () => handleCloseModal() }
						>
							Close
						</button>
					</div>
				</div>
			);
		}


		if (membersBFFStore.isModalDataLoading) {
			return (
				<div
					className="mzd-subscribe-modal-body-loading"
					style={ {
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						minHeight: '10rem',
					} }
				>
					<div className="loading-spinner large">
						<div />
					</div>
				</div>
			);
		}

		/**
		 * // Example of getting the list of cards for this member
		 * member.getCreditCardList().then((cardList) => {
 		 *
 		 * });
 		 *
 		 * // You can also use...
 		 * const cardList = await member.getCreditCardList();
 		 * // ...from inside an async function
		 */

		return (
			<div className="checkout margin-horizontal-1 margin-bottom-1">

				<CheckoutFormHeader
					name={ artist.name }
				/>
				<CheckoutFormCardDisplay 
					membersBFFStore={membersBFFStore}
					member={member}
					artistID={artist.id}  
					forceUpdate={forceUpdate}
				/>


				{formElem === "newCard" &&
					<div className="grid-x align-middle">

						{/*Card Num*/}
						<div className="grid-x margin-bottom-2 cell small-12">
							<div className="cell small-5 margin-right-1 underlined-field">
								<Field
									fieldKey="user.cardName"
									formStore={ formStore }
									item={ member }
									placeholder="Name on Card"
								/>
							</div>
							<div className="cell small-5 margin-right-1">
								<label className="card-elem-label">
									Card Number
									<div className="underlined-field">
										<CardNumberElement
											id="subscribeCardNumber"
											options={ CARD_ELEMENT_OPTIONS }
										></CardNumberElement>
									</div>
								</label>
							</div>
						</div>

						{/*Card Expiry and CVC*/}
						<div className="grid-x margin-bottom-2 cell small-12">
							<div className="cell small-5 margin-right-1">
								<label className="card-elem-label">
									Expiration Date
									<div className="underlined-field">
										<CardExpiryElement
											id="subscribeCardExpirationDate"
											options={ CARD_ELEMENT_OPTIONS }
										></CardExpiryElement>
									</div>
								</label>
							</div>
							<div className="cell small-5 margin-right-1">
								<label className="card-elem-label">
									CVC
									<div className="underlined-field">
										<CardCvcElement
											id="subscribeCardCVC"
											options={ CARD_ELEMENT_OPTIONS }
										></CardCvcElement>
									</div>
								</label>
							</div>
						</div>

						{/*Card Expiry and CVC*/}
						<div className="grid-x cell small-12">
							<div className="cell small-5 margin-bottom-2 underlined-field">
								<Field
									fieldKey="user.postalCode"
									formStore={ formStore }
									item={ member }
									placeholder="#####"
								/>
							</div>
						</div>

						<SubmitButton />
					</div>
				}
			</div>
		);
	}
));
